import { ErrorOrError } from "../../../core/results/error-or/models/error-or-error.model";

export const invalidCredentialsError = ErrorOrError.unAuthorized(
  'Login failed',
  'Please check your email and password and try again.')


